/* VanillaGoods My Kitchen: the one-time welcome for a member's first visit, and "Bake it forward", the member's personal
   invite link with share buttons. Friends who join through the link are counted on the member's profile by the sync
   service (apps_script/my_kitchen_sync.gs, action "welcome"), which also sends new members the welcome email. */
(function () {
  var root = document.querySelector('[data-mk]');
  var me = window.vgMe;
  if (!root || !root.querySelector('.mk-shell') || !me || !me.signedIn || !me.ref) return;

  var SHARE_TEXT = 'I use VanillaGoods for free baking classes, 4,000+ vanilla recipes and great vanilla. Join free:';
  var link = location.origin + (me.kitchen || '/pages/my-kitchen') + '?ref=' + me.ref;
  var SEEN = 'vg_welcomed_' + me.ref;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function track(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* no analytics */ } }
  function profile() { return (me.profile && me.profile()) || {}; }
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; } return null; }

  var ICON = {
    heart: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
    repeat: '<path d="M4 12a8 8 0 0 1 14-5.3L20 9"/><path d="M20 4v5h-5"/><path d="M20 12a8 8 0 0 1-14 5.3L4 15"/><path d="M4 20v-5h5"/>',
    play: '<circle cx="12" cy="12" r="9"/><path d="M10 8.5v7l6-3.5z"/>',
    book: '<path d="M5 4h10a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3z"/><path d="M5 17a3 3 0 0 1 3-3h10"/>',
    pen: '<path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/>',
    pin: '<path d="M12 21s-6-5.5-6-11a6 6 0 0 1 12 0c0 5.5-6 11-6 11z"/><circle cx="12" cy="10" r="2.2"/>',
    calendar: '<rect x="4" y="5" width="16" height="15" rx="2"/><path d="M4 10h16M9 3v4M15 3v4"/>',
    spark: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/>',
    share: '<circle cx="18" cy="5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="19" r="2.5"/><path d="M8.2 10.8l7.6-4.4M8.2 13.2l7.6 4.4"/>',
    copy: '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>',
    mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6.5L12 13l8.5-6.5"/>',
    chat: '<path d="M4 5h16v11H9l-5 4z"/>'
  };
  function svg(n) { return '<svg aria-hidden="true" viewBox="0 0 24 24">' + ICON[n] + '</svg>'; }

  /* Free features; "go" opens a My Kitchen section, "href" another page */
  var FEATURES = [
    ['heart', 'My Kitchen on every device', 'Saved recipes, articles, products, markets, events and books in one place.', { go: 'recipes' }],
    ['repeat', 'One-click reorder', 'Every past order, ready to buy again.', { go: 'orders' }],
    ['play', 'Free Baking Academy', '60 video lessons in 12 courses, with notes, tools and your progress saved.', { href: '/pages/baking-academy' }],
    ['book', '4,000+ vanilla recipes', 'Scale servings, cook along step by step, print or save any recipe.', { href: '/pages/recipes' }],
    ['pen', 'Share your recipes', 'Our test kitchen reviews them and publishes them with your name.', { go: 'submissions' }],
    ['pin', 'Farmers Market Finder', 'Find markets near you and keep your favorites a tap away.', { href: '/pages/farmers-market-finder' }],
    ['calendar', 'Events calendar', 'Coffee, tea and food festivals and holidays, with calendar reminders.', { href: '/pages/vanilla-coffee-tea-events-calendar' }],
    ['spark', 'Picks for you', "Tell us how you bake and we'll suggest lessons, recipes and products.", { go: 'profile' }]
  ];
  var LINKS = [['The Journal', '/pages/blog-search-page'], ['Extract calculator', '/pages/extract-calculator'],
               ['Make your own extract', '/pages/make-your-own-extract'], ['The Bookshelf', '/pages/bookshelf'],
               ['Shop vanilla, coffee and tea', '/collections/all'], ['FAQ', '/pages/frequently-asked-question']];

  /* ---------- sharing ---------- */
  function shareButtons(where) {
    var enc = encodeURIComponent, msg = SHARE_TEXT + ' ' + link;
    var items = [
      navigator.share ? '<button type="button" class="mk-share-btn mk-share-btn--main" data-share="native">' + svg('share') + 'Share</button>' : '',
      '<button type="button" class="mk-share-btn" data-share="copy">' + svg('copy') + '<span data-copy-label>Copy link</span></button>',
      '<a class="mk-share-btn" data-share="email" href="mailto:?subject=' + enc('Join me on VanillaGoods') + '&body=' + enc(msg) + '">' + svg('mail') + 'Email</a>',
      '<a class="mk-share-btn" data-share="text" href="sms:?&body=' + enc(msg) + '">' + svg('chat') + 'Text</a>',
      '<a class="mk-share-btn" data-share="facebook" target="_blank" rel="noopener" href="https://www.facebook.com/sharer/sharer.php?u=' + enc(link) + '">Facebook</a>',
      '<a class="mk-share-btn" data-share="whatsapp" target="_blank" rel="noopener" href="https://wa.me/?text=' + enc(msg) + '">WhatsApp</a>',
      '<a class="mk-share-btn" data-share="pinterest" target="_blank" rel="noopener" href="https://www.pinterest.com/pin/create/button/?url=' + enc(link) + '&description=' + enc(SHARE_TEXT) + '">Pinterest</a>'
    ];
    return '<div class="mk-invite-link"><label class="mk-visually-hidden" for="mk-invite-' + where + '">Your invite link</label>' +
      '<input id="mk-invite-' + where + '" type="text" readonly value="' + esc(link) + '"></div>' +
      '<div class="mk-share" data-share-where="' + where + '">' + items.join('') + '</div>';
  }
  function onShare(e) {
    var b = e.target.closest('[data-share]');
    if (!b) return;
    var how = b.getAttribute('data-share'), box = b.closest('[data-share-where]'), where = box ? box.getAttribute('data-share-where') : '';
    track('invite_share', { method: how, location: where });
    if (how === 'native') {
      e.preventDefault();
      navigator.share({ title: 'Join me on VanillaGoods', text: SHARE_TEXT, url: link }).catch(function () { /* closed */ });
    } else if (how === 'copy') {
      e.preventDefault();
      var label = b.querySelector('[data-copy-label]');
      var done = function () { if (label) { label.textContent = 'Copied'; setTimeout(function () { label.textContent = 'Copy link'; }, 2000); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(done, function () { selectLink(b); });
      else selectLink(b);
    }
  }
  function selectLink(b) {
    var box = b.closest('.mk-invite, .mkw-invite'), input = box && box.querySelector('input');
    if (input) { input.focus(); input.select(); }
  }

  function drawInvite() {
    var card = root.querySelector('[data-mk-invite]');
    if (!card) return;
    var slim = root.classList.contains('mk-invite-slim');   // set by vg-my-kitchen.js after a few visits with no friends joined
    card.innerHTML = '<div class="mk-cardhead"><h2>Bake it forward</h2><span class="mk-pill mk-pill--ok" data-invite-count></span></div>' +
      (slim ? '<p class="mk-sub">Know someone who bakes? <button type="button" class="mk-link" data-invite-expand>Show my invite link</button></p>'
        : '<p class="mk-sub">Know someone who bakes? Share your invite link. They get everything in My Kitchen free, and you\'ll see here how many friends joined.</p>' + shareButtons('card'));
    var n = Number(profile().invites) || 0, pill = card.querySelector('[data-invite-count]');
    pill.textContent = n ? n + (n === 1 ? ' friend joined' : ' friends joined') : 'Invite friends';
    card.hidden = false;
  }
  root.addEventListener('click', onShare);
  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-invite-expand]')) return;
    root.classList.remove('mk-invite-slim');
    drawInvite();
    track('invite_expand', {});
  });

  /* ---------- the welcome ---------- */
  var lastFocus = null;
  function showWelcome() {
    var first = me.first ? ', ' + esc(me.first) : '';
    var wrap = document.createElement('div');
    wrap.className = 'mkw-layer';
    wrap.innerHTML = '<div class="mkw-backdrop" data-mkw-close></div>' +
      '<div class="mkw" role="dialog" aria-modal="true" aria-labelledby="mkw-title" tabindex="-1">' +
      '<button type="button" class="mkw-x" data-mkw-close aria-label="Close">&times;</button>' +
      '<div class="mkw-hero"><p class="mkw-eyebrow">Welcome to VanillaGoods</p><h2 id="mkw-title">We\'re so glad you joined' + first + '.</h2>' +
      '<p>Thank you for becoming part of VanillaGoods. We\'re a small, young company bringing single-origin vanilla straight from growers ' +
      'around the bean belt to kitchens like yours. This is <strong>My Kitchen</strong>, your own corner of the site.</p></div>' +
      '<div class="mkw-body">' +
      '<h3>Everything here is free</h3><ul class="mkw-features">' +
      FEATURES.map(function (f) {
        var tag = f[3].href ? 'a href="' + f[3].href + '"' : 'button type="button" data-mkw-go="' + f[3].go + '"';
        return '<li><' + tag + ' class="mkw-feature">' + svg(f[0]) + '<span><strong>' + esc(f[1]) + '</strong><span>' + esc(f[2]) + '</span></span></' + tag.split(' ')[0] + '></li>';
      }).join('') + '</ul>' +
      '<div class="mkw-growing mkw-gift"><strong>Your welcome gift:</strong> 15% off your first order with code <b>WELCOME-VG</b>, plus two free vanilla eBooks. Both are waiting in My Kitchen under Orders &amp; reorder.</div>' +
      '<div class="mkw-growing"><strong>We\'re new, and growing with you.</strong> My Kitchen will grow as we do. Next on our list: reorder reminders, ' +
      'baking milestones and a place for members to share tips with each other. Have an idea? Write to us at ' +
      '<a href="mailto:help@vanillagoods.com">help@vanillagoods.com</a>. We read every message.</div>' +
      '<div class="mkw-invite"><h3>Bake it forward</h3><p>Know someone who would love this? Share your personal invite link, and you\'ll see in My Kitchen how many friends joined.</p>' +
      shareButtons('welcome') + '</div>' +
      '<p class="mkw-links"><span>Helpful links:</span> ' + LINKS.map(function (l) { return '<a href="' + l[1] + '">' + esc(l[0]) + '</a>'; }).join(' \u00b7 ') + '</p>' +
      '<div class="mkw-acts"><button type="button" class="mk-btn mk-btn--solid" data-mkw-close>Start exploring</button>' +
      '<button type="button" class="mk-btn" data-mkw-go="profile">Tell us how you bake</button></div>' +
      '</div></div>';
    root.appendChild(wrap);
    lastFocus = document.activeElement;
    document.documentElement.classList.add('mkw-open');
    var dlg = wrap.querySelector('.mkw');
    dlg.focus();
    function close(go) {
      document.documentElement.classList.remove('mkw-open');
      document.removeEventListener('keydown', onKey);
      wrap.remove();
      if (go) { if (typeof window.vgMkGo === 'function') window.vgMkGo(go); else { var nav = root.querySelector('.mk-nav [data-mk-go="' + go + '"]'); if (nav) nav.click(); } }
      else if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = dlg.querySelectorAll('a[href], button, input');
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
    document.addEventListener('keydown', onKey);
    wrap.addEventListener('click', function (e) {
      var g = e.target.closest('[data-mkw-go]');
      if (g) { track('welcome_action', { action: 'go_' + g.getAttribute('data-mkw-go') }); close(g.getAttribute('data-mkw-go')); return; }
      if (e.target.closest('[data-mkw-close]')) { track('welcome_action', { action: 'close' }); close(); }
    });
    track('welcome_shown', {});
  }

  function markWelcomed() {
    store(SEEN, '1');
    if (me.api >= 3 && typeof me.send === 'function') {
      me.send('welcome', { ref: me.invitedBy ? me.invitedBy() : '' }).then(function (res) {
        if (res && res.ok) { try { window.localStorage.removeItem('vg_ref'); } catch (e) { /* blocked */ } drawInvite(); }
      });
    }
  }

  drawInvite();
  if (!profile().welcomed && (!store(SEEN) || me.api >= 3)) {
    if (!store(SEEN)) setTimeout(showWelcome, 350);
    markWelcomed();
  }
})();
